<div class="input-group">
  @if (prependIcon) {
    <div class="input-group-prepend">
      <span class="input-group-text">
        <span class="material-symbols-outlined">
          {{ prependIcon }}
        </span>
      </span>
    </div>
  }

  @if (inputType === 'input') {
    <input
      (keyup)="keyUp($event)"
      [type]="type"
      [formControl]="control"
      class="form-control"
    />
  }

  @if (inputType === 'date') {
    <p-datepicker
      [formControl]="control"
      dateFormat="dd.mm.yy"
      [showIcon]="true"
      [showButtonBar]="true"
      styleClass="w-100"
      inputStyleClass="w-100"
    />
  }

  @if (inputType === 'textarea') {
    <textarea
      (keyup)="keyUp($event)"
      [rows]="rows"
      [class.is-invalid]="invalid"
      [attr.aria-invalid]="invalid || control.invalid"
      [formControl]="control"
      class="form-control"
    ></textarea>
  }

  @if (inputType === 'checkbox') {
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        [formControl]="control"
        [id]="checkboxId"
      />
      @if (description !== undefined) {
        <label class="pe-2" [for]="checkboxId">
          {{ description | translate }}
        </label>
      }
    </div>
  }

  @if (inputType === 'select') {
    <p-select
      [formControl]="control"
      [options]="selectOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="selectPlaceholder"
      [invalid]="control.invalid && control.touched"
      [fluid]="true"
    />
  }

  @if (inputType === 'multi-select') {
    <p-multiselect
      [formControl]="control"
      [options]="selectOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="selectPlaceholder"
      [invalid]="control.invalid && control.touched"
      [fluid]="true"
      [showToggleAll]="false"
    />
  }

  @if ((listOfErrors() | keyvalue).length > 0) {
    <div class="invalid-feedback">
      <ul>
        @for (error of listOfErrors() | keyvalue; track error.key) {
          <li>{{ error.key | translate: error.value }}</li>
        }
      </ul>
    </div>
  }
</div>
@if (helpText) {
  <div class="form-text">{{ helpText }}</div>
}
